// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"c39912e2","605":"8bb17c79","809":"62452d41","981":"76958a5c"}[chunkId] + ".chunk.js";
};